/**
 * The map's selected location, kept current while its sheet is open.
 *
 * The location sheet decides each stall's Start from the location it
 * renders. Rendering the snapshot captured when the pin was tapped let a
 * stall that had since gone busy, offline or into maintenance keep a live
 * Start, so MapPage refreshes the list while a location is selected and
 * renders the sheet from the latest copy.
 *
 * Pure so it can be tested without React.
 */

/** How often the locations list refreshes while a sheet is open: modest,
 *  on top of the refresh the tap itself fires, and nothing at all while
 *  no sheet is open. */
export const SHEET_REFRESH_MS = 30_000;

/** The latest copy of `snapshot` in `list`, found by _id; the snapshot
 *  itself while the list does not have it (still loading, or the
 *  location left the list since the tap). Null when nothing is selected. */
export function latestById<T extends { _id: string }>(
  list: readonly T[],
  snapshot: T | null,
): T | null {
  if (!snapshot) return null;
  return list.find((l) => l._id === snapshot._id) ?? snapshot;
}
